"use client";

import React from "react";
import { ArrowRight, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const applications = [{
  title: "Diritto Societario",
  description: "Assistenza strategica nella costituzione di società, operazioni di M&A e governance aziendale. Progettiamo strutture legali solide per la crescita e la protezione del capitale.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/legal_corporate_icon.png",
  badge: "Corporate",
  badgeColor: "bg-primary/10 text-primary border-primary/20",
  link: "/LegalTopicsOverviewPage"
}, {
  title: "Diritto Immobiliare",
  description: "Consulenza integrata per transazioni immobiliari complesse, sviluppi urbanistici e gestione di patrimoni. Un approccio architettonico alla tutela del real estate.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/legal_realestate_icon.png",
  badge: "Real Estate",
  badgeColor: "bg-primary/10 text-primary border-primary/20",
  link: "/LegalTopicsOverviewPage"
}, {
  title: "Consulenza Fiscale",
  description: "Pianificazione tributaria nazionale ed internazionale volta all'ottimizzazione del carico fiscale. Gestione rigorosa del contenzioso e conformità normativa.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/legal_tax_icon.png",
  badge: "Tax & Finance",
  badgeColor: "bg-primary/10 text-primary border-primary/20",
  link: "/ConsultingPage"
}, {
  title: "Responsabilità 231",
  description: "Implementazione di modelli organizzativi per la prevenzione dei reati societari. Audit periodici e formazione per garantire una compliance aziendale impeccabile.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/legal_compliance_icon.png",
  badge: "Compliance",
  badgeColor: "bg-primary/10 text-primary border-primary/20",
  link: "/EntityResponsibilityPage"
}];
export default function ApplicationCards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}